import { Redirect } from 'react-router-dom';
import React from 'react';

import { User } from '../../../tools';

const Logout = () => {
  User.clear();
  return <Redirect to="/account/login" />;
};

export default Logout;
